export const socialsData = {
  github: "https://github.com/Sangamchoudhary",
  linkedIn: "https://www.linkedin.com/in/sangamchoudhary-a909661b0/",
  leetcode: "https://leetcode.com/_Pinocchio/",
  codechef : "https://www.codechef.com/users/sangam244",
  codeforces: "https://codeforces.com/profile/sangamchoudhary"
};
